import TypeLabel from './TypeLabel';

import './TypeLabel.scss';

export default TypeLabel;
